/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import {
    downloadCsvFile,
    downloadOutboundCsvFile,
    fetchAllCSvOrders,
    fetchAllCSvOutboundOrders,
    pollCsv,
    pollOutboundCsv,
    putCsvUrl,
    putOutboundCsvUrl,
    useDownloadResultant,
    useUploadCsvFile,
    useUploadCsvServer,
    useUploadOutboundCsvFile,
} from '../../hooks/useCsvOrder';
import CsvDetailsCard from '../CsvDetailsCard/CsvDetailsCard';
import './manageCsv.scss';
import { upload as uploadToServer } from '../../utils/axios-utils';
import { SlidersTwoTone } from '@ant-design/icons';
import useLogout from '../../hooks/useLogout';

var interval = 0;
const ManageCsv = props => {
    const [fileName, setFileName] = useState('');
    const [fileStatus, setFileStatus] = useState(false);
    const [file, setFile] = useState('');
    const [csvIds, setCsvIds] = useState([]);
    const [inProgressCsv, setInProgressCsv] = useState([]);
    const getCsv = () => (props.csvType == 'outbound' ? fetchAllCSvOutboundOrders(props.csvId) : fetchAllCSvOrders(props.csvId));
    const { refetch: getFetchAllCsvLists } = useQuery([props.csvType == 'outbound' ? 'csvOrdersOutbound' : 'csvOrders', props.csvId], getCsv, {
        enabled: false,
    });
    const getCsvUrl = () => putCsvUrl([props.csvId, fileName]);
    let id = props.csvId;
    const { refetch } = useQuery(['csvOrders', id, fileName], getCsvUrl, {
        enabled: false,
    });
    const { logout } = useLogout();

    const onSuccessCsv = data => {
        // debugger
        let csvUrl = data.data.url;
        const link = document.createElement('a');
        link.href = csvUrl;
        link.setAttribute('download', `FileName.pdf`);
        document.body.appendChild(link);
        link.click();
    };

    const { refetch: downloadCsv } = useQuery(
        [props.csvType == 'outbound' ? 'csvIdOrderIdOutbound' : 'csvIdOrderId', csvIds[0], csvIds[1]],
        props.csvType == 'outbound' ? downloadOutboundCsvFile : downloadCsvFile,
        {
            enabled: false,
            onSuccess: onSuccessCsv,
        }
    );

    const { mutate: getResultantFile } = useDownloadResultant(onSuccessResultant, onResultErr);

    function onSuccessResultant(response) {
        console.log('first', response);
        var blob = new Blob([response.data], {
            type: response.headers['content-type'],
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let filename = response.headers['content-disposition'].split('filename=')[1].split('.')[0];

        link.setAttribute('download', `${filename}.xlsx`);
        document.body.appendChild(link);
        link.click();
    }
    function onResultErr(err) {
        console.log('first err', err);
        if (err?.response?.status === 401) logout();
    }

    const onSuccessFileUpload = data => {
        // debugger;
    };

    const OnSuccessEntery = data => {
        // debugger;
        setFileStatus(false);
        setFile(null);
        setFileName('');
        getFetchAllCsvLists();
        alert(' file uploaded successfully');
        //alert("success");
        handleApiPoll();
    };
    const OnSuccessEnteryOB = data => {
        // debugger;
        setFileStatus(false);
        setFile(null);
        setFileName('');
        getFetchAllCsvLists();
        alert(' file uploaded successfully');
        //alert("success");
        handleApiPoll();
    };
    const onError = data => {
        alert('error');
        if (data?.response?.status === 401) logout();
    };
    const { mutate: csvUploardFileUrl } = useUploadCsvFile(OnSuccessEntery, onError);
    const { mutate: csvUploardOutboundFileUrl } = useUploadOutboundCsvFile(OnSuccessEnteryOB, onError);
    const { mutate: finalUploadCsvServer } = useUploadCsvServer(onSuccessFileUpload, onError);

    const handleApiPoll = () => {
        interval = setInterval(async () => {
            let result = await (props.csvType == 'outbound' ? pollOutboundCsv(props.csvId) : pollCsv(props.csvId));
            console.log('neww', result);
            let newData = result.data.filter(el => el.parseStatus == 'pending').map(elm => elm._id);
            if (newData.length > 0) {
                setInProgressCsv(newData);
            } else {
                clearInterval(interval);
                getFetchAllCsvLists();
            }
        }, 2500);
    };

    useEffect(() => {
        if (csvIds.length !== 0) {
            downloadCsv();
        }
        return () => {
            clearInterval(interval);
        };
    }, [csvIds]);

    useEffect(() => {
        // debugger;
        if (fileStatus) {
            const cb = async () => {
                const result = await refetch();
                // debugger;
                if (result) {
                    uploadToServer(
                        {
                            'Content-Type': file.type,
                        },
                        {
                            url: result.data.data.url,
                            method: 'PUT',
                            data: file,
                        }
                    )
                        .then(res => {
                            // debugger;
                            (props.csvType == 'outbound' ? csvUploardOutboundFileUrl : csvUploardFileUrl)([
                                props.csvId,
                                {
                                    key: result.data.data.key,
                                    fileName: file.name,
                                },
                            ]);
                        })
                        .catch(err => {
                            alert('Error while uploading file.');
                            if (err?.response?.status === 401) logout();
                        });
                }
            };

            cb();
            // final file upload on server
            // finalUploadCsvServer([result.data.data.url, file]);
        }
    }, [fileStatus, refetch]);

    const uploadFile = e => {
        let img = e.target.files[0];
        if (!img.name.includes('.csv')) {
            alert('Please upload only csv file');
        } else {
            setFile(img);
            let file = img.name;
            setFileName(file);
            setFileStatus(true);
        }
    };

    const downloadFileCsv = data => {
        setCsvIds(data);
    };

    const downloadResultant = (oId, csvId) => {
        let tempObj = { orderId: oId, csvId: csvId };
        getResultantFile(tempObj);
    };

    return (
        <div className="csv_container">
            <div className="csv_header">
                <h4 style={{ textTransform: 'capitalize' }}>Manage {props.csvType} CSV</h4>
            </div>
            <div className="csv_section">
                <h5>--------Order Name--------</h5>
                <div className="csv_detail">
                    {props?.csvOrder &&
                        props?.csvOrder?.map(el => {
                            return (
                                <CsvDetailsCard
                                    csvFileName={el.fileName}
                                    uploadDateAndTime={el.createdAt}
                                    userName={el.createdBy.name}
                                    validationStatus={el.isValidated}
                                    attachStatus={el.isActive}
                                    failedResponse={el.parseResponse}
                                    parseStatus={el.parseStatus}
                                    orderId={el.Oid}
                                    csvId={el._id}
                                    downloadFileCsv={downloadFileCsv}
                                    inProgressCsv={inProgressCsv}
                                    csvType={props.csvType}
                                    downloadResultant={downloadResultant}
                                />
                            );
                        })}
                </div>
                <div className="csv_btn_legend">
                    <Button
                        style={{
                            margin: '0 8px',
                        }}
                        size="small"
                    >
                        DOWNLOAD CSV SAMPLE
                    </Button>
                    <div>
                        <div className="btn_container">
                            {props?.csvType !== 'outbound' ? (
                                <>
                                    <label htmlFor="files" className="upload_btn">
                                        Upload CSV
                                    </label>
                                    <input
                                        style={{
                                            visibility: 'hidden',
                                        }}
                                        id="files"
                                        onChange={e => uploadFile(e)}
                                        type="file"
                                        name="uploadCsv"
                                    />
                                </>
                            ) : null}
                            <Button
                                onClick={() => {
                                    props.setCsvId('');
                                    props.setShowCsvModal(false);
                                }}
                                size="small"
                            >
                                Done
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageCsv;
